import { render, staticRenderFns } from "./GaleriaDestaque.vue?vue&type=template&id=852f8282&"
import script from "./GaleriaDestaque.vue?vue&type=script&lang=js&"
export * from "./GaleriaDestaque.vue?vue&type=script&lang=js&"
import style0 from "./GaleriaDestaque.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports